import { connect } from 'react-redux';
import { Dispatch } from '@reduxjs/toolkit';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectProduct } from 'src/redux/selectors';
import { DeliveryArea, DeliveryAreaProps, DispatchProps } from '../components';
import { onDeliveryAreaReturnsPolicyClick, onDeliveryAreaToggle } from '../modules';

const mapStateToProps = (state: ReduxApplicationState): DeliveryAreaProps => ({
  inventoryStatus: state.product.inventoryStatus,
  product: selectProduct(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onDeliveryAreaToggle: (isOpen) => dispatch(onDeliveryAreaToggle(isOpen)),
  onDeliveryAreaReturnsPolicyClick: () => dispatch(onDeliveryAreaReturnsPolicyClick()),
});

export const DeliveryAreaContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryArea);
